import '/src/scss/main.scss'
import jQuery from "jquery"

Object.assign(window, { $: jQuery, jQuery })
